import {
	createApp
} from 'vue'
import App from './App.vue'

createApp(App).mount('#app')


function setRem() {
	const docEl = document.documentElement
	const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'

	function recalc() {
		const clientWidth = docEl.clientWidth
		if (!clientWidth) return

		if (clientWidth >= 1350) { // PC端
			docEl.style.fontSize = 100 * (clientWidth / 1920) + 'px'
		} else { // 移动端
			docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
		}
	}

	window.addEventListener(resizeEvt, recalc, false)
	document.addEventListener('DOMContentLoaded', recalc, false)
}

setRem()

import 'vue3-layer/dist/s3Layer.css';